<template lang="">
  <div class="chart-container">
    <canvas ref="salesChart"></canvas>
  </div>
</template>
<script>

import { Chart } from 'chart.js/auto'

export default {
  name: 'SalesChart',
  mounted() {
    const ctx = this.$refs.salesChart.getContext('2d')

    // Generate labels from October 15th to October 29th
    const labels = Array.from({ length: 15 }, (_, i) => {
      const date = new Date(2025, 9, 15 + i) // month 9 = October (0-indexed)
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    })

    new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Sales (Ksh)',
            data: [1200, 1500, 1800, 2200, 1900, 2500, 2700, 3000, 2800, 3100, 2900, 3500, 3700, 3600, 4000],
            borderColor: '#42A5F5',
            backgroundColor: 'rgba(66, 165, 245, 0.2)',
            fill: true,
            tension: 0.4,
            pointBackgroundColor: '#1E88E5',
            pointRadius: 5
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Sales Trend: October 15th – 29th, 2025',
            font: { size: 16 }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Sales (Ksh)'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Date'
            }
          }
        }
      }
    })
  }
}

</script>
<style scoped>
.chart-container {
  width: 100%;
  height: 60vh;
  padding: 1rem;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>